import { createStyles, makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  padding-top: 120px;
`;
export const Name = styled.h3`
  color: white;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 500;
`;
export const Status = styled.h4`
  color: white;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
`;
export const useLayoutStyles = makeStyles(() =>
  createStyles({
    paper: {
      margin: 'auto',
      marginTop: '120px',
      maxWidth: 670,
    },
    box: {
      minHeight: '95vh',
      paddingLeft: '100px',
      paddingRight: '100px',
    },
  }),
);
export const useStyles = makeStyles((theme) => ({
  serverBox: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  boxTitle: {
    color: 'black',
    fontWeight: 'bold',
    margin: 0,
  },
}));
